import styled, { css, keyframes } from 'styled-components';

import { fadeIn, fadeOut } from '../../../../styles/shared.style';

interface WrapperMenuProps {
    $isVisible: boolean
    $shouldRender: boolean
}

export const slideInFromBottom = keyframes`
  from {
    transform: translateY(0);
    opacity: 0;
  }
  to {
    transform: translateY(-30px);
    opacity: 1;
  }
`;

export const slideOutToBottom = keyframes`
  from {
    transform: translateY(-30px);
    opacity: 1;
  }
  to {
    transform: translateY(0);
    opacity: 0;
  }
`;

export const StyledDropDownMenu = styled.section`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap : 0.4rem;
    cursor: pointer;
    margin-left: -1.2rem;
`;

export const StyledArrowIcon = styled.img`
    cursor: pointer;
`;

export const StyledContentMenu = styled.section<WrapperMenuProps>`
    position: absolute;
    top: 2rem;
    right: 0;
    min-width: 5rem;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 1.5rem;
    z-index: 2000000;
    padding: 0 0.5rem;
    display: ${({ $shouldRender }) => $shouldRender ? 'flex' : 'none'};
    border: 1px solid ${({ theme }) => theme.colors.border};

    animation: ${({ $isVisible }) => $isVisible
    ? css`${slideOutToBottom} 0.2s ease-out, ${fadeIn} 0.2s ease-out`
    : css`${slideInFromBottom} 0.2s ease-in, ${fadeOut} 0.2s ease-in`};

    -webkit-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.27);
    -moz-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.27);
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.27);
`;
